export interface UpdateUserAbnRequest {
  abn: string
  businessName: string
  crn: string | null
}

export interface UpdateEnquiryAbnRequest {
  abn: string
  businessName: string
  enquiryId: string | null
}

export class NewABN {
  abn = ''
  businessName = ''
  crn: string | null = null
  enquiryId: string | null = null
}
